// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-data-state-container[data-v-16d52987] {\n  min-height: 29vh;\n}\n.no-data-state-container h5[data-v-16d52987] {\n  font-size: 1.1rem !important;\n  opacity: 0.4;\n}\n", ""]);
// Exports
module.exports = exports;
